// extracted by mini-css-extract-plugin
module.exports = {"container":"EventTimer_container__wa5_F","name":"EventTimer_name__tJSfo","link":"EventTimer_link__2EGyp"};